<template>
    <div class="position-relative px-2 pb-4 pb-md-0 conversation-wrap">
        <div class="d-flex justify-content-center">
            <!--                <button class="btn btn-primary" ref="show_more" v-on:click="showMore">
                                <span class="text">{{ trans('general.defaults.show_more') }}</span>
                            </button>-->
            <v-wait for='loading-messages' class="icon" v-if="$wait.is('loading-messages')">
                <HalfCircleSpinner slot='waiting' :size="32" :color="'#503E9D'"/>
            </v-wait>
        </div>
        <div class="conversation position-relative overflow-auto mb-4 mb-md-5" :class="{'padding-files': files.length > 0}"
             v-chat-scroll="{always: false, smooth: true, notSmoothOnInit: true, scrollonremoved:true, smoothonremoved: false}" ref="conversation"
             @v-chat-scroll-top-reached="showMore">
            <div v-if="messages.length === 0" class="d-flex flex-column align-items-center">
                <img class="w-75 d-lg-none" src="/img/msg-icon2.png" alt="no messages">
                <img class="w-50 d-none d-lg-block" src="/img/msg-icon2.png" alt="no messages">
            </div>
            <div v-for="message in messages">
                <div class="message d-flex" v-if="message.sender.id !== senderId">
                    <div class="mt-2">
                        <h6 class="h6 fw-bold mb-0 text-left ms-2">{{ message.sender.name }} {{
                                message.sender.surname
                            }}</h6>
                        <div class="message-content border-radius-20 bg-light-green text-dark-green p-3">
                            <div :class="{'card-columns': message.images.length > 1}">
                                <div class="card bg-transparent" v-for="image in message.images">
                                    <img v-img="{group: 'message' + message.id}" class="cover border-radius-20 m-1"
                                         :src="image.path" alt="" height="150" width="150">
                                </div>
                            </div>
                            {{ message.message }}
                        </div>
                        <div class="fs-12 text-end pe-2">{{ message.created_at  | moment("from", "now") }}</div>
                    </div>
                </div>

                <div class="message d-flex justify-content-end" v-if="message.sender.id === senderId">
                    <div class="mt-2">
                        <h6 v-if="roles[0].name === roleService.ADMIN" class="h6 fw-bold mb-0 me-2 text-end">
                            {{ message.sender.name }} {{ message.sender.surname }}</h6>
                        <h6 v-if="roles[0].name !== roleService.ADMIN" class="h6 fw-bold mb-0 me-2 text-end">
                            {{ trans('general.page.messages.me') }}</h6>
                        <div class="message-content border-radius-20  bg-light-blue text-primary p-3">
                            <div :class="{'card-columns': message.images.length > 1}">
                                <div class="card bg-transparent" v-for="image in message.images">
                                    <img v-img="{group: 'message' + message.id}" class="cover border-radius-20 m-1"
                                         :src="image.path" alt="" height="150" width="150">
                                </div>
                            </div>
                            {{ message.message }}
                        </div>
                        <div class="fs-12 ps-2">{{ message.created_at  | moment("from", "now") }}</div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>
import RoleService from "../../../services/RoleService";
import {HalfCircleSpinner, OrbitSpinner} from 'epic-spinners'
import {
    CHANEL_CHILD_MESSAGE,
    CHANEL_STAFF_MESSAGE,
    EVENT_MESSAGE_SENT,
    generateConversationID
} from "../../../services/WebSocketsConfigs";

export default {
    name: "Conversation",
    props: {childId: Number, userId: Number, senderId: Number, receiverId: Number, roles: Array, messageSent: Object},
    data() {
        return {
            messages: [],
            users: [],
            page: 1,
            limit: 10,
            lastPage: null,
            roleService: RoleService,
            files: []
        }
    },
    components: {
        HalfCircleSpinner,
        OrbitSpinner
    },
    watch: {
        receiverId: function (val, old) {
            this.reload();
            this.childId ? this.joinRoom(old) : this.joinStaffRoom(old);
            this.markAllRead();
        },
        senderId: function (val, old) {
            this.reload();
            this.childId ? this.joinRoom(old) : this.joinStaffRoom(old);
        },
        messageSent: function (val) {
            this.messages.push(val);
        },
        users: function (val) {
            this.$emit('users-changed', this.users)
        }
    },

    methods: {
        leaveRoom() {
            this.childId
                ? Echo.leave(`${CHANEL_CHILD_MESSAGE}${this.childId}.${generateConversationID(this.senderId,  this.receiverId)}`)
                : Echo.leave(`${CHANEL_STAFF_MESSAGE}${generateConversationID(this.senderId,  this.receiverId)}`);
        },
        joinRoom(oldReceiver) {
            if (oldReceiver) {
                Echo.leave(`${CHANEL_CHILD_MESSAGE}${this.childId}.${generateConversationID(this.senderId, oldReceiver)}`);
            }
            Echo.join(`${CHANEL_CHILD_MESSAGE}${this.childId}.${generateConversationID(this.senderId, this.receiverId)}`)
                .here((users) => {
                    this.users = users
                })
                .leaving((user) => {
                    this.users = this.users.filter((val) => val.id !== user.id)
                })
                .joining((user) => {
                    this.users.push(user)
                })
                .listen(EVENT_MESSAGE_SENT, (data) => {
                    this.messages.push(data.message);
                });
        },
        joinStaffRoom(oldReceiver) {
            if (oldReceiver) {
                Echo.leave(`${CHANEL_STAFF_MESSAGE}${generateConversationID(this.senderId, oldReceiver)}`);
            }

            Echo.join(`${CHANEL_STAFF_MESSAGE}${generateConversationID(this.senderId, this.receiverId)}`)
                .here((users) => {
                    this.users = users
                })
                .leaving((user) => {
                    this.users = this.users.filter((val) => val.id !== user.id)
                })
                .joining((user) => {
                    this.users.push(user)
                })
                .listen(EVENT_MESSAGE_SENT, (data) => {
                    this.messages.push(data.message);
                });
        },
        load() {
            this.$wait.start("loading-messages")
            let url = (this.childId) ? `/messages/child/${this.childId}/conversation`
                : `/messages/staff/conversation`;

            axios.get(url, {
                params: {
                    receiver_id: this.receiverId,
                    sender_id: this.senderId,
                    limit: this.limit,
                    page: this.page,
                    include: 'sender;receiver;images',
                    order_by: 'created_at',
                    sorted_by: 'DESC',
                }
            }).then((response) => {
                let data = response.data.data;

                this.messages = [...data.data.reverse(), ...this.messages];
                this.$wait.end("loading-messages")
                this.lastPage = data.last_page;
                // if (data.last_page === this.page) {
                // if(this.$refs.show_more)
                //     this.$refs.show_more.setAttribute('class', 'd-none');
                // }
            });
        },

        reload() {
            let me = this;
            setTimeout(function () {
                me.messages = [];
                me.users = [];
                me.files = [];
                me.page = 1;
                me.limit = 15;
                // me.$refs.show_more.setAttribute('class', 'btn btn-primary');
                me.load();
            }, 100)

        },

        showMore() {
            if (!this.lastPage || this.lastPage > this.page) {
                this.page = this.page + 1;
                this.load()
            }

        },

        markAllRead() {
            axios.post(`/messages/mark-read-all`, {senderId: this.receiverId})
                .then((response) => {
                    this.$emit('marked-all-read', response.data)
                });
        }
    },
    mounted() {
        this.load();
        this.childId ? this.joinRoom() : this.joinStaffRoom();
        this.markAllRead();
    },
    destroyed() {
        this.leaveRoom();
    }
}
</script>

<style scoped>
.conversation::-webkit-scrollbar {
    display: none;
}

.conversation {
    min-height: 400px;
    max-height: 400px;
    height: 400px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}

.padding-files {
    margin-bottom: 90px !important;
}
</style>
